import http from './http'

class Btg {
  feePerTerm (payload) {
    return http.get(
      `/btg/configurations?fund_id=${payload.fund_id}&payer_id=${payload.payer_id}`
    )
  }

  feePerTermDowload (id) {
    return http.get(
      `/btg/configurations/download_file?id=${id}`
    )
  }

  feePerTermUpload (payload) {
    return http.post('/btg/configurations/', payload)
  }
}

export default new Btg()



// WEBPACK FOOTER //
// ./src/services/btg.js